/**
 * Calculate years of experience from a start date
 * @param startDate - Start date in format "YYYY-MM" or Date object
 * @returns Number of years of experience (rounded to 1 decimal place)
 */
export const calculateYearsOfExperience = (startDate: string | Date): number => {
  const start = typeof startDate === 'string' 
    ? new Date(startDate + '-01') 
    : startDate;
  
  const now = new Date();
  const diffTime = Math.abs(now.getTime() - start.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  const diffYears = diffDays / 365.25;
  
  // Round to 1 decimal place
  return Math.round(diffYears * 10) / 10;
};

/**
 * Get formatted years of experience string
 * @param startDate - Start date in format "YYYY-MM"
 * @returns Formatted string like "5+" (whole years with +)
 */
export const getExperienceYears = (startDate: string = '2021-02'): string => {
  const years = calculateYearsOfExperience(startDate);
  // Return whole years with "+" (no decimal point)
  return `${Math.floor(years)}+`;
};
